import {RouterCreator} from "../../typings";

export function defineRouterCreator(option: RouterCreator): () => RouterCreator{
    return () => option;
}
